/** @format */

import { combineReducers } from 'redux';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './user/user.reducer.js';
import flightDataReducer from './flightData/flightData.reducer.js';
import customerReducer from './customers/customer.reducer.js';
import messageReducer from './message/message.reducer.js';
import messageTemplateReducer from './message-template/message-template.reducer.js';
import trueblueFormReducer from './form-trueblue/from-trueblue.reducer.js';
import tbautomationreducer from './tb-automation/tb-automation.reducer.js';
import newhirereducer from './new-hire/new-hire.reducer.js';
import terminationreducer from './termination/termination.reducer.js';
import valetDataReducer from './valetData/valetData.reducer.js';
import pingHandlerReducer from './ping-handler/ping-handler.reducer';
import stationChecklistReducer from './stationChecklist/station-checklist.reducer.js';
import newHireEditorReducer from './new-hire-ref/new-hire-ref.reducer.js';
import pairingModelReducer from './pairing-model/pairing-model.reducer.js';
import voucherReducer from './voucher/voucher.reducer.js';
import messageHistoryReducer from './message-history/message-history.reducer.js';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'customer', 'tbautomation', 'newhire', 'termination'],
};

const rootReducer = combineReducers({
  user: userReducer,
  customer: customerReducer,
  message: messageReducer,
  messageTemplate: messageTemplateReducer,
  flightData: flightDataReducer,
  trueBlueFormData: trueblueFormReducer,
  tbautomation: tbautomationreducer,
  newhire: newhirereducer,
  termination: terminationreducer,
  valetData: valetDataReducer,
  pingHandler: pingHandlerReducer,
  stationChecklist: stationChecklistReducer,
  newHireEditor: newHireEditorReducer,
  pairingModel: pairingModelReducer,
  voucher: voucherReducer,
  messageHistory: messageHistoryReducer,
});

export default persistReducer(persistConfig, rootReducer);
